import { WS_URL } from "./config";

const CLOSE_GRACE_PERIOD_MS = 250;

let socket = null;
let socketUserKey = "";
let consumerCount = 0;
let closeTimer = null;

const clearScheduledClose = () => {
  if (closeTimer !== null) {
    clearTimeout(closeTimer);
    closeTimer = null;
  }
};

const isReusable = (candidate) => (
  candidate
  && [WebSocket.CONNECTING, WebSocket.OPEN].includes(candidate.readyState)
);

export const buildWebSocketUrl = (user, websocketOrigin = WS_URL) => {
  if (!user?.id || !user?.email || !websocketOrigin) return "";
  const origin = websocketOrigin.replace(/\/$/, "");
  return `${origin}/ws/notifications/${encodeURIComponent(user.id)}/${encodeURIComponent(user.email)}/`;
};

export const connectWebSocket = (user) => {
  const wsUrl = buildWebSocketUrl(user);
  if (!wsUrl) {
    console.warn("Notification connection is unavailable because its configuration is incomplete.");
    return null;
  }

  const userKey = `${user.id}:${user.email}`;
  if (socketUserKey === userKey && isReusable(socket)) {
    clearScheduledClose();
    consumerCount += 1;
    return socket;
  }

  clearScheduledClose();
  if (socket) {
    socket.close();
  }
  socket = null;
  socketUserKey = "";
  consumerCount = 0;

  let nextSocket;
  try {
    nextSocket = new WebSocket(wsUrl);
  } catch (_error) {
    console.warn("Notification connection could not be started.");
    return null;
  }

  socket = nextSocket;
  socketUserKey = userKey;
  consumerCount = 1;

  nextSocket.onclose = () => {
    if (socket === nextSocket) {
      socket = null;
      socketUserKey = "";
      consumerCount = 0;
      clearScheduledClose();
    }
  };
  nextSocket.onerror = () => {
    // The browser reports a failed connection once. Reconnects are user/session driven.
  };

  return nextSocket;
};

export const disconnectWebSocket = () => {
  if (!socket) return;

  consumerCount = Math.max(0, consumerCount - 1);
  if (consumerCount > 0 || closeTimer !== null) return;

  const socketToClose = socket;
  closeTimer = setTimeout(() => {
    closeTimer = null;
    if (socket === socketToClose && consumerCount === 0) {
      socketToClose.close();
    }
  }, CLOSE_GRACE_PERIOD_MS);
};

export const getWebSocket = () => socket;

export const sendMessage = (message) => {
  if (!socket || socket.readyState !== WebSocket.OPEN) return false;
  socket.send(JSON.stringify(message));
  return true;
};
